define([
    "jquery",
    "underscore",
    "marionette",
    "behaviors/form_errors_behavior",
    "behaviors/file_upload_behavior",
    "forms/register/register_step2_form",
    "forms/register/register_step3_form",
    "moment",
    "behaviors/countdown_behavior",
    "bootstrap.datepicker",
    "backbone.syphon",
    "holdon"
], function($, _, Marionette, FormErrorsBehavior, FileUploadBehavior, Step2Form, Step3Form, moment, CountdownBehavior) {
    return Marionette.View.extend({
        el: '#content_layout',

        behaviors: {
            formErrors: {
                behaviorClass: FormErrorsBehavior
            },
            fileUpload: {
                behaviorClass: FileUploadBehavior
            },
            countdown: {
                behaviorClass: CountdownBehavior,
            }
        },

        ui:{
            'step2': '#step2',
            'step3': '#step3',
            'nextStepBtn': '.next_step',
            'previousStepBtn': '.prev_step',
            'submitBtn': '.submit_button',
            'birthDatePicker': '#birth',
            'pleFile': '#ple_file',
            'pleName': '#ple_name',
            'ple': '#ple',
            'poaFile': '#poa_file',
            'poaName': '#poa_name',
            'poa': '#poa',
            'form': '#register_form',
            'inputs': '.form-control',
            'signatureStep2': '#signature_2',
            'signatureNameStep2': '#signature_2_name',
            'signatureStep3': '#signature_3',
            'signatureNameStep3': '#signature_3_name',
            'registrationOption': '#registration_option',
            'languageSelect': '#language_cd',
            'citizenshipCountrySelect': '#citizenship_country_cd',
            'addressCountryCd': '#address_country_cd',
            'mobileCountry': '#mobile_country',

            // Phone validation ==
            'phoneCode': '#mobile_country',
            'phoneArea': '#mobile_area',
            'phoneRest': '#mobile_rest',
            'oldPhoneNumber': '#old_phone_number',

            'email' : '#email',
        },

        events:{
            'click @ui.nextStepBtn': 'nextStep', // step2에서 다음
            'click @ui.previousStepBtn': 'previousStep',
            'click @ui.submitBtn': 'submit', // step3 최종 제출
            'click @ui.agreeTermsIco': 'toggleCheckBox',
            'change @ui.registrationOption': 'redirectUser',
            'change @ui.languageSelect' : 'changePresetLanguageValues',
            'change @ui.citizenshipCountrySelect' : 'changePhoneCountryPresetValue',
            // 'change @ui.addressCountryCd' : 'changePhoneCountryPresetValue', // We should not do this, it's bad UX
            'keypress @ui.inputs': function(e){
                if(13 === e.keyCode){
                    e.preventDefault();
                    if(4 === this.step){
                        this.submit();
                    }else{
                        this.nextStep();
                    }
                }
            },
            'keyup @ui.signatureNameStep2': function(e){
                if(e) e.preventDefault();

                this.updateSignature(this.ui.signatureNameStep2, this.ui.signatureStep2);
            },
            'keyup @ui.signatureNameStep3': function(e){
                if(e) e.preventDefault();

                this.updateSignature(this.ui.signatureNameStep3, this.ui.signatureStep3);
            },
        },

        initialize: function(){
            this.bindUIElements();

            this.step = 2;

            this.step2Form = new Step2Form();
            this.step3Form = new Step3Form();

            // this.ui.birthDatePicker.datetimepicker({
            //     viewMode: 'years',
            //     format: 'YYYY-MM-DD',
            //     // We need to be 20years old to register to let's have the max date be 20years from now
            //     // maxDate: moment().subtract(18, 'y')
            // });
            // Clear the input (it's set by default to the max date, but we want it empty)
            if(this.ui.birthDatePicker.data("DateTimePicker")){
                this.ui.birthDatePicker.data("DateTimePicker").date(null);
            }

            this.triggerMethod('init:file:upload', {
                $selector: this.ui.pleFile,
                type: 'ple',
                baseUrl: '/rest_register/'
            });
            this.triggerMethod('init:file:upload', {
                $selector: this.ui.poaFile,
                type: 'poa',
                baseUrl: '/rest_register/'
            });

            // this.displayPhoneValidation();

            //countdown
            this.isCountdownEnd = false;
        },

        redirectUser: function(e) {
            e.preventDefault();

            var registrationOption = $(e.currentTarget).val();
            var targetUrl = [baseUrl+'register', registrationOption].join('/')+window.location.search;
            if(history.replaceState){
                history.replaceState({}, document.title, targetUrl);
            }
            window.location = targetUrl;
        },

        changePresetLanguageValues: function(){

            let that = this;
            $.ajax({
                url: '/rest_register/get_country_cd_by_language_cd',
                method: "POST",
                data:{
                    language_cd: that.ui.languageSelect.val(),
                },
                success: function(data){
                    $(that.ui.citizenshipCountrySelect).val(data.country_cd);
                    $(that.ui.addressCountryCd).val(data.country_cd);
                    $(that.ui.mobileCountry).val(data.phone_country);
                    that.displayPhoneValidation();
                }
            });
        },

        changePhoneCountryPresetValue: function(){

            let country_cd;
            if(this.ui.citizenshipCountrySelect.val()){
                country_cd = this.ui.citizenshipCountrySelect.val();
            }
            else {
                country_cd = this.ui.addressCountryCd.val();
            }

            let that = this;
            $.ajax({
                url: '/rest_register/get_phone_country_by_country_cd',
                method: "POST",
                data:{
                    country_cd: country_cd,
                },
                success: function(data){
                    $(that.ui.mobileCountry).val(data.phone_country);
                    that.displayPhoneValidation();
                }
            });
        },

        updateSignature: function($signatureName, $signature){
            // Filter all characters that are not a-z A-Z
            $signatureName.val($signatureName.val().replace(/[^a-zA-Z .,]/g, function(str){
                return '';
            }));

            $signature.val($signatureName.val());
        },

        previousStep: function(e){
            if(e) e.preventDefault();

            this.changeStep(this.step, this.step-1);
        },

        nextStep: function(e){
            if(e) e.preventDefault();

            HoldOn.open({
                theme:"sk-fading-circle"
            });
            var that = this;

            $.when(
                this.checkCurrentStepValid()
            ).done(function(){
                that.changeStep(that.step, that.step + 1);
            }).always( function(){
                HoldOn.close();
            });
        },

        changeStep: function(previousStep, newStep){
            this.hideStep(previousStep);
            this.showStep(newStep);
            this.step = newStep;
        },

        hideStep: function(step){
            this.ui['step'+step].hide();
        },

        showStep: function(step){
            this.ui['step'+step].show();
            // Scroll to the top of the new active step
            $('html, body').animate({
                scrollTop: this.ui['step'+step].offset().top
            }, 0);
            this.ui['step'+step].find('input, select').first().focus();
        },

        checkCurrentStepValid: function(){
            var that = this;

            this.triggerMethod('hide:errors');
            var formData = Backbone.Syphon.serialize(this);

            var form = this['step'+this.step+"Form"];
            form.set(formData);

            var errors = form.validate();
            var d = $.Deferred();

            if(!errors){
                return form.validateWithServer({
                    success: function(model, response){
                        //d.resolve();
                    },
                    error: function(model, error){
                        that.triggerMethod('show:errors', error.responseJSON);
                    }
                });
            }else{
                d.reject();
                this.triggerMethod('show:errors', errors);
            }
            return d.promise();
        },

        submit: function(e){
            if(e) e.preventDefault();

            HoldOn.open({
                theme:"sk-fading-circle"
            });

            var that = this;

            $.when(
                this.checkCurrentStepValid()
            ).done(function(){
                that.ui.form.submit();
            }).fail(function(){
                HoldOn.close();
            });
        }
    });
});
